import { render, staticRenderFns } from "./CompanyLanguageCombobox.vue?vue&type=template&id=d2bcb69e&"
import script from "./CompanyLanguageCombobox.vue?vue&type=script&lang=js&"
export * from "./CompanyLanguageCombobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports